import TextWeightHover from '../components/TextWeightHover.js'

export default class HomePage {
  constructor({ touch } = {}) {
    this.textHover = new TextWeightHover({ touch })

    this.getElems()
  }

  update(dt) {
    this.textHover.update(dt)
  }

  getElems() {
    this.birthYear = document.querySelector('.js-year')
    this.birthYear.textContent = this.getAge('2000/11/3')
  }

  getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
  }
}
